import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ErrorDialog } from '../../shared/dialogs/error/error.dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(private dialog: MatDialog, private translocoService: TranslocoService) {
  }

  public handleError(error: HttpErrorResponse, showErrorWithTitle?: string): string | undefined {
    if ((error as any).isAuthHandled) {
      return;
    }

    let errorMessage!: string;

    switch (error.status) {
      case 400:
        errorMessage = this.translocoService.translate("error.status_code.400");
        break;
      case 401:
        errorMessage = this.translocoService.translate("error.status_code.401");
        break;
      case 403:
        errorMessage = this.translocoService.translate("error.status_code.403");
        break;
      case 404:
        errorMessage = this.translocoService.translate("error.status_code.404");
        break;
      default:
        errorMessage = this.translocoService.translate("error.unexpected");
    }

    if (showErrorWithTitle) {
      this.dialog.open(ErrorDialog, {
        data: { title: showErrorWithTitle, description: errorMessage },
        autoFocus: false
      });
    }

    return errorMessage;
  }
}


